module.exports = __webpack_public_path__ + "img/app.f9276b2f.png";